export default "__VITE_ASSET__Cc2B_ZOr__"